module.exports = __webpack_public_path__ + "zwijanie.png?ee06fb62c80697a3f10f7a9621c3f087";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zwijanie.png
// module id = 1022
// module chunks = 2